import { Link } from 'react-router-dom';
import './footer.css';
import React from "react";


export default function Derechos() {
    return (
        <footer >
            <div id="footer" className="footer">

                <div className="footer-contenido">
                    {/* Columna 1: Logo */}
                    <div className="footer-columna logo">
                        <img src="logos/logo_fbmclm.webp" alt="Logo de la empresa" className="footer-logo" />
                    </div>

                    {/* Columna 2: Redes sociales */}
                    <div className="footer-columna redes-sociales-footer">
                        <a
                            href="https://www.instagram.com/fbmclm?igsh=N3l1eTBqanNqM2xu"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="redes-logo"
                            aria-label="Instagram"
                        >
                            <img src="/logos/logo-instagram.png" alt="Instagram" />
                        </a>

                        <a
                            href="https://www.facebook.com/FBMCLM"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="redes-logo"
                            aria-label="WhatsApp"
                        >
                            <img src="/logos/logo-facebook.png" alt="WhatsApp" />
                        </a>
                        
                    </div>

                    {/* Columna 3: Enlaces a secciones */}
                    <div className="footer-columna">
                        <a className="enlaces-footer" href="mailto:fbmclm@fbmclm.es">
                            fbmclm@fbmclm.es
                        </a>
                        <a className="enlaces-footer" href="tel:+34613003523">
                            613 00 35 23
                        </a>                        
                    </div>

                    {/* Columna 4: Información legal */}
                    <div className="footer-columna">                       
                        <Link className="enlaces-footer" to="/privacidad">Política de Privacidad</Link>
                        <Link className="enlaces-footer" to="/cookies">Política de Cookies</Link>
                    </div>
                </div>
                <div id="end"></div>
            </div>

            <div className="derechos">
                <div className="derechos-content">
                    <a href="https://www.noos-solutions.es" target="_blank" rel="noopener noreferrer">
                        <img src="logos/powered_by_blanco.png" alt="Imagen de derechos" className="derechos-image" />
                    </a>        <p>&copy; 2025 Federación de Balonmano de Castilla- La Mancha . Todos los derechos reservados.</p>
                </div>
            </div>
        </footer>
    );
}
